module.exports = __webpack_public_path__ + "static/media/radiant-bright.814d7edd.png";